import React, { useCallback, useMemo } from 'react';
import { t } from '@lingui/core/macro';

import { Paragraph, Text } from '@rover/kibble/core';
import { AccordionItem } from '@rover/react-lib/src/components/lists/Accordion';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import {
  HomePageFooterAccordionCollapsed,
  HomePageFooterAccordionExpanded,
} from './analyticsEvents';

export const ROVER_DATA_CITATION = (): string => t`Global data from Rover (November 2025)`;

export type Citation = string | React.ReactNode;

export type Props = {
  citations: Citation[];
};

type SuperscriptProps = { children: React.ReactNode };

export const Superscript: React.FC<SuperscriptProps> = ({ children }) => (
  <Text as="sup" size="100" mx="1x">
    {children}
  </Text>
);

const FactCitations: React.FC<Props> = ({ citations }) => {
  const eventProperties = useMemo(() => ({ dropDownName: `Reference for pet facts` }), []);
  const handleAccordionToggle = useCallback(
    (isOpen: boolean) => {
      const EventCtor = isOpen ? HomePageFooterAccordionExpanded : HomePageFooterAccordionCollapsed;
      emitAnalyticsEvent(new EventCtor(eventProperties));
    },
    [eventProperties]
  );

  return (
    <AccordionItem
      itemHeading={t`Reference for pet facts`}
      itemBody={
        <>
          {citations.map((citation, index) => (
            <Paragraph
              key={index + 1}
              textColor="secondary_inverse"
              ml="4x"
              webProps={{ maxWidth: 'none' }}
              sx={{ textIndent: '-16px' }} // 16px = 4x
            >
              <Superscript>{index + 1}</Superscript>
              {citation}
            </Paragraph>
          ))}
        </>
      }
      onToggle={handleAccordionToggle}
      testID="footer-accordion-citations"
    />
  );
};

export default FactCitations;
